document.addEventListener('DOMContentLoaded', function() {
    const switchModeBtn = document.querySelector('.switch-mode-btn');

    switchModeBtn.addEventListener('click', function() {
        switchModeBtn.classList.toggle('__active');
        let mode = localStorage.getItem('isDarkOrLight');

        if (!mode) {
            // Correction de la détection du mode initial
            if (window.matchMedia('(prefers-color-scheme: light)').matches) {
                mode = 'light';
            } else {
                mode = 'dark';
            }
        }

        if (mode === 'dark') {
            mode = 'light';
        } else {
            mode = 'dark';
        }
        setDarkOrLight(mode);
    });

    function setDarkOrLight(mode) {
        const body = document.querySelector('body');
        if (mode === 'dark') {
            body.classList.add('dark-mode');
            body.classList.remove('light-mode');
            localStorage.setItem('isDarkOrLight', 'dark');
        } else {
            body.classList.add('light-mode');
            body.classList.remove('dark-mode');
            localStorage.setItem('isDarkOrLight', 'light');
        }
    }

    let mode = localStorage.getItem('isDarkOrLight');
    if (!mode) {
        // Correction de la détection du mode initial
        if (window.matchMedia('(prefers-color-scheme: light)').matches) {
            mode = 'light';
        } else {
            mode = 'dark';
        }
    }
    setDarkOrLight(mode);
});
